import React from 'react';
import Layout from '../../components/Layout';
import { CalendarIcon } from 'lucide-react';
const IntakePeriods: React.FC = () => {
  return <Layout title="Intake Periods" persona="University Coordinator" universityName="UAE Business School" data-id="element-6089">
      <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-6090">
        <div className="text-center py-16" data-id="element-6091">
          <div className="mx-auto w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mb-4" data-id="element-6092">
            <CalendarIcon className="w-8 h-8 text-gray-400" data-id="element-6093" />
          </div>
          <h3 className="text-gray-500 font-medium mb-2" data-id="element-6094">
            Intake Periods content coming soon
          </h3>
          <p className="text-gray-400 text-sm max-w-md mx-auto" data-id="element-6095">
            This page will allow you to manage application intake periods for
            your programs.
          </p>
        </div>
      </div>
    </Layout>;
};
export default IntakePeriods;